import React from 'react';
import { Skeleton } from 'antd';
import './style.scss';

interface IProps {
  type?: 'horizontal' | 'vertical';
}

export const ActivitySkeletonFilters: React.FC<IProps> = ({ type = 'horizontal' }) => {
  if (type === 'vertical') {
    return (
      <div className="skeleton-filters-vertical">
        {[1, 2, 3].map((group) => (
          <div key={group} className="skeleton-filters-group">
            <Skeleton active title={{ width: '40%' }} paragraph={false} className="group-title" />
            {[1, 2, 3].map((item) => (
              <div key={item} className="skeleton-filter-item">
                <Skeleton.Avatar active size="small" shape="square" className="item-checkbox" />
                <Skeleton active title={{ width: '60%' }} paragraph={false} className="item-label" />
                <Skeleton active title={{ width: '20%' }} paragraph={false} className="item-count" />
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="skeleton-filters-horizontal">
      <div className="skeleton-pill main-pill">
        <div className="skeleton-pill__inner">

          <Skeleton.Button active shape="round" />
        </div>
      </div>
      <Skeleton.Button active shape="round" className="skeleton-pill" />
      <Skeleton.Button active shape="round" className="skeleton-pill" />
      <Skeleton.Button active shape="round" className="skeleton-pill" />
    </div>
  );
};
